import React, { Suspense, Fragment as F } from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import { Fragment } from 'redux-little-router'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

import LoadingQuote from 'components/AppStatus/LoadingQuote'
import Loading from 'discada/dist/Loading'

import Nav from 'components/Nav'

import Naughty from 'components/widgets/Naughty'
import AppStatus from 'components/AppStatus'
import Footer from './Footer'

import HubspotChat from 'components/widgets/Hubspot'
import FacebookPixel from 'components/widgets/FacebookPixel'
import GoogleTagManager from 'components/widgets/GoogleTagManager'
import PageTitle from './PageTitle'
import { FourOhFour, FiveHundred } from './error'

import AbeChat from 'components/widgets/AbeChat'

import SocketHealth from 'components/widgets/SocketHealth'
import Modals from './Modals'

import { setupAuthWatcher } from 'actions/authActions'
import { getIsLoggedIn } from 'selectors/authSelectors'
import { getAuthData } from 'selectors/authSelectors'
import { updateBrowserInfo, updateRooftopId } from 'actions/appStatusActions'
import {
  getRooftopInfo,
  getTheme,
  isPaymentIQView,
  getTaggedCustomerFromState,
} from 'selectors/appStatusSelectors'

import { getQueryValue, getParamValue } from 'selectors/pageStateSelectors'

import {
  tagCustomer,
  tagDealerUser,
  flushByType,
  trackOpen,
} from 'actions/naughtyActions'

import { setUpSocketForRooftop } from 'actions/appStatusActions'

import CustomScripts from 'components/widgets/CustomScripts'

const Inventory = React.lazy(() => import('./inventory'))
const Vehicle = React.lazy(() => import('./vehicle'))
const Lead = React.lazy(() => import('./lead'))
const Stats = React.lazy(() => import('./stats'))
const AllStatsPage = React.lazy(() => import('./allStats'))
const Settings = React.lazy(() => import('./settings'))
const QuoteLink = React.lazy(() => import('./quoteLink'))
const CrmLink = React.lazy(() => import('./crmLink'))
const Map = React.lazy(() => import('components/Map'))
const Login = React.lazy(() => import('./cognitoLogin'))
const RequestReset = React.lazy(() => import('./cognitoRequestReset'))
const SubmitReset = React.lazy(() => import('./cognitoSubmitReset'))
const SetupSettings = React.lazy(() => import('./setup'))

const MagicLinker = React.lazy(() => import('components/widgets/MagicLinker'))
const PaymentIQ = React.lazy(() => import('components/widgets/PaymentIQ'))

class App extends React.Component {
  bootstrap() {
    let {
      browser,
      updateBrowserInfo,
      rooftopId,
      updateRooftopId,
      version,
    } = this.props

    updateBrowserInfo(browser, version)
    updateRooftopId(rooftopId)
  }

  componentDidMount() {
    let {
      setupAuthWatcher,
      trackOpen,
      isLoggedIn,
      tagDealerUser,
      tagCustomer,
    } = this.props

    this.bootstrap()
    setupAuthWatcher()
    setTimeout(trackOpen, 1000)

    isLoggedIn ? tagDealerUser() : tagCustomer()

    this.props.setUpSocketForRooftop()
  }

  componentDidUpdate() {
    let { rooftopId, rooftopInfo } = this.props

    if (isEmpty(rooftopInfo)) updateRooftopId(rooftopId)

    this.props.setUpSocketForRooftop()
  }

  render() {
    let { browser, theme, rooftopInfo, printModal, paymentIqView } = this.props

    return (
      <div
        className={c(
          'app-container',
          `browser-${get(browser, 'name')}`,
          `browser-version-${get(browser, 'version')}`,
          `theme-${theme}`,
          { 'print-modal': printModal, 'payment-iq': paymentIqView },
        )}
      >
        <PageTitle />

        {!paymentIqView && !paymentIqView && <Nav />}
        <Fragment forRoute="/">
          <div className="app-container-inner">
            <Fragment forRoute="/">
              <Suspense fallback={<Loading />}>
                <Login />
              </Suspense>
            </Fragment>
            <Fragment forRoute="/setup">
                <Suspense fallback={<Loading />}>
                    <SetupSettings/>
                </Suspense>
            </Fragment>
            <Fragment forRoute="/forgot-password">
              <Suspense fallback={<Loading />}>
                <RequestReset />
              </Suspense>
            </Fragment>
            <Fragment forRoute="/reset-password">
              <Suspense fallback={<Loading />}>
                <SubmitReset />
              </Suspense>
            </Fragment>

            <Fragment forRoute="/:dealerId">
              <Suspense fallback={<Loading />}>
                {isEmpty(rooftopInfo) ? (
                  <LoadingQuote showProgressBar />
                ) : (
                  <F>
                    <Fragment forRoute="/inventory">
                      <Inventory />
                    </Fragment>
                    <Fragment forRoute="/vehicle/:id/:condition/:year/:make/:model/:trim">
                      <Vehicle />
                    </Fragment>
                    <Fragment forRoute="/vehicle/:id/:condition/:year/:make/:model">
                      <Vehicle />
                    </Fragment>
                    <Fragment forRoute="/vehicle/:id/:condition/:year/:make">
                      <Vehicle />
                    </Fragment>
                    <Fragment forRoute="/vehicle/:id/:condition/:year">
                      <Vehicle />
                    </Fragment>
                    <Fragment forRoute="/vehicle/:id/:condition">
                      <Vehicle />
                    </Fragment>
                    <Fragment forRoute="/vehicle/:id">
                      <Vehicle />
                    </Fragment>
                    <Fragment forRoute="/lead">
                      <Lead />
                    </Fragment>
                    <Fragment forRoute="/stats/all">
                      <AllStatsPage />
                    </Fragment>
                    <Fragment forRoute="/stats/map">
                      <Map />
                    </Fragment>
                    <Fragment forRoute="/stats">
                      <Stats />
                    </Fragment>
                    <Fragment forRoute="/settings">
                      <Settings />
                    </Fragment>
                    <Fragment forRoute="/magicLinker">
                      <MagicLinker />
                    </Fragment>
                    <Fragment forRoute="/paymentIQ">
                      <PaymentIQ />
                    </Fragment>
                    <Fragment forRoute="/l">
                      <CrmLink />
                    </Fragment>
                    <Fragment forRoute="/q/:id">
                      <QuoteLink />
                    </Fragment>
                    <Fragment forRoute="/b/:id">
                      <QuoteLink blinder />
                    </Fragment>
                    <Fragment forRoute="/404">
                      <FourOhFour />
                    </Fragment>
                    <Fragment forRoute="/500">
                      <FiveHundred />
                    </Fragment>
                    <Fragment forRoute="/">
                      <Inventory />
                    </Fragment>
                  </F>
                )}
              </Suspense>
            </Fragment>
            <Fragment forNoMatch>
              <FourOhFour frikin />
            </Fragment>
          </div>
        </Fragment>
        <Footer />

        {!isEmpty(rooftopInfo) && <GoogleTagManager />}
        {!isEmpty(rooftopInfo) && <FacebookPixel />}

        <Modals />
        <AppStatus />
        <Naughty />
        <HubspotChat />
        <AbeChat />
        <SocketHealth />

        <CustomScripts />
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let ret = {
    ...op,
    theme: getTheme(state),
    authData: getAuthData(state),
    rooftopId: getParamValue(state, 'dealerId'),
    rooftopInfo: getRooftopInfo(state),
    isLoggedIn: getIsLoggedIn(state),
    printModal: getQueryValue(state, 'printModal'),
    paymentIqView: isPaymentIQView(),
    taggedCustomer: getTaggedCustomerFromState(state),
  }

  return ret
}

export default connect(
  mapStateToProps,
  {
    updateBrowserInfo,
    updateRooftopId,
    setupAuthWatcher,
    flushByType,
    tagCustomer,
    tagDealerUser,
    trackOpen,
    setUpSocketForRooftop,
  },
)(App)
